import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  messagesLimit = signal(50);
  conversationLimit = signal(10);
  iosVersion: Signal<number | null> = signal(this.getIOSVersion());
  readonly #minimumMessageSizeWithGap = 44;

  setMessagesLimit(limit: number) {
    this.messagesLimit.set(limit);
  }

  setConversationLimit(limit: number) {
    this.conversationLimit.set(limit);
  }

  getIOSVersion(): number | null {
    const userAgent = window.navigator.userAgent;
    // iOS user agents contain "OS 15_" or "OS 16_" for iOS 15 and 16
    const match = userAgent.match(/OS (\d+)_/i);
    if (match && match[1]) {
      return parseInt(match[1], 10);
    }
    return null;
  }

  calculateLimitSize(element: HTMLElement, setDefaultMessagesLimit: boolean = false): number {
    if (!element) {
      console.warn('Element is not found to calculate the limit size');
      return 100;
    }
    // Checking how big is the container and trying to calculate the limit with the most smallest chat messsage
    const messagesWrapperHeight = element.offsetHeight;

    const limitToHaveScrollbar = Math.ceil(messagesWrapperHeight / this.#minimumMessageSizeWithGap);
    const limit = limitToHaveScrollbar > 3 ? limitToHaveScrollbar : 3;
    if (setDefaultMessagesLimit) {
      this.messagesLimit.set(limit);
    }
    return limit;
  }
}
